import { epicRequest } from 'app'
import System from 'system'

export const TEAM_FETCH = 'TEAM_FETCH'
export const TEAM_FETCH_ERROR = 'TEAM_FETCH_ERROR'
export const TEAM_FETCH_FULFILLED = 'TEAM_FETCH_FULFILLED'
export const TEAM_FETCH_CANCELED = 'TEAM_FETCH_CANCELED'

export const TEAM_LIKE = 'TEAM_LIKE'
export const TEAM_LIKE_ERROR = 'TEAM_LIKE_ERROR'
export const TEAM_LIKE_FULFILLED = 'TEAM_LIKE_FULFILLED'
export const TEAM_LIKE_CANCELED = 'TEAM_LIKE_CANCELED'

export const TEAM_RELATION_FETCH = 'TEAM_RELATION_FETCH'
export const TEAM_RELATION_FETCH_ERROR = 'TEAM_RELATION_FETCH_ERROR'
export const TEAM_RELATION_FETCH_FULFILLED = 'TEAM_RELATION_FETCH_FULFILLED'
export const TEAM_RELATION_FETCH_CANCELED = 'TEAM_RELATION_FETCH_CANCELED'

export const TEAM_INITIAL_STATE = {
  data: [],
  error: null,
  pagination: null,
}

export const teamRelationFetch = (teamId) => ({
  payload: {
    teamId,
  },
  type: TEAM_RELATION_FETCH,
})

export const teamRelationFetchFulfilled = (payload) => ({
  payload,
  type: TEAM_RELATION_FETCH_FULFILLED,
})
export const teamRelationFetchError = (payload) => ({
  payload,
  type: TEAM_RELATION_FETCH_ERROR,
})

export const teamRelationFetchCanceled = () => ({
  payload: null,
  type: TEAM_RELATION_FETCH_CANCELED,
})

export const teamRelationFetchEpic = epicRequest({
  actionType: TEAM_RELATION_FETCH,
  errorAction: teamRelationFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: teamRelationFetchFulfilled,
  request: ({ payload }) => `sports/soccer/team/${payload.teamId}/relation`,
  untilTypes: TEAM_RELATION_FETCH_CANCELED,
})

export const teamFetch = (teamId) => ({
  payload: {
    teamId,
  },
  type: TEAM_FETCH,
})

export const teamFetchFulfilled = (payload) => ({
  payload,
  type: TEAM_FETCH_FULFILLED,
})
export const teamFetchError = (payload) => ({
  payload,
  type: TEAM_FETCH_ERROR,
})

export const teamFetchCanceled = () => ({
  payload: null,
  type: TEAM_FETCH_CANCELED,
})

export const teamFetchEpic = epicRequest({
  actionType: TEAM_FETCH,
  errorAction: teamFetchError,
  fulfilledAction: teamFetchFulfilled,
  maps: [(_response, { payload }) => teamRelationFetch(payload.teamId)],
  request: ({ payload }) => `sports/soccer/team/${payload.teamId}`,
  untilTypes: TEAM_FETCH_CANCELED,
})

export const teamLike = (teamId, like) => ({
  payload: {
    like,
    teamId,
  },
  type: TEAM_LIKE,
})

export const teamLikeFulfilled = (payload) => ({
  payload,
  type: TEAM_LIKE_FULFILLED,
})
export const teamLikeError = (payload) => ({
  payload,
  type: TEAM_LIKE_ERROR,
})

export const teamLikeCanceled = () => ({
  payload: null,
  type: TEAM_LIKE_CANCELED,
})

export const teamLikeEpic = epicRequest({
  actionType: TEAM_LIKE,
  errorAction: teamLikeError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: teamLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: `sports/soccer/team/${payload.teamId}/${payload.like ? 'like' : 'unfollow'}`,
  }),
  untilTypes: TEAM_LIKE_CANCELED,
})
